<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs :crm_id="this.$route.params.crmid"/>
            <div class="basic-title">
              <em v-if="status===0">IELTS雅思能力测试（{{ report.qs_paper_type }}） </em><!-- 列表显示基础班，历史记录显示时间-->
              <div class="ieltsTest-button" >
                <el-button
                  type="primary"
                  size="mini"
                  @click="changeVersion"
                  v-if="userStatus.paper_type ===0 ">开通尊享版</el-button>
                <em v-if="userStatus.paper_type===1">已开通尊享版 </em>
                <el-button
                  type="primary"
                  size="mini"
                  @click="makeWxAppCode"
                  v-if="userStatus.paper_type===1">用户二维码</el-button>
              </div>
            </div>
            <div
              class="ieltsTest-cont"
              v-if="status===0">
              <el-row v-if="report.length !== 0">
                <el-col
                  :span="4"
                  class="ieltsTest-left ieltsTest-left-top">
                  <span><em>雅思预测分数</em><em>{{ report.report_json[6].point }}</em></span>
                </el-col>
                <el-col :span="1"/>
                <el-col
                  :span="19"
                  class="ieltsTest-right ieltsTest-right-top">
                  <div class="ieltsTest-right-box">
                    <span v-if="true"><i>完成时间：</i>{{ report.add_time }}</span>
                    <span><i>答题耗时：</i>{{ report.done_time }}</span>
                  </div>
                  <div class="ieltsTest-right-box">
                    <span><i>总分：</i>{{ report.report_json[6].last_score }}</span>
                    <span><i>学习建议：</i>{{ report.report_json[6].comment }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row
                v-for="(item, index) in report.report_json"
                :key="index"
                v-if="index != 6">
                <el-col
                  :span="4"
                  class="ieltsTest-left">
                  <span>
                    <em>{{ item.name }}：{{ item.last_score }}</em>
                    <em>预测分数：{{ item.point }}</em>
                  </span>
                </el-col>
                <el-col :span="1">评语：</el-col>
                <el-col
                  :span="19"
                  class="ieltsTest-right">
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="item.comment"/>
                </el-col>
              </el-row>
              <el-row v-if="status===0"> <!-- 列表显示-->
                <el-col :span="5"/>
                <el-col :span="19">
                  <el-button
                    type="primary"
                    @click="save">保存报告并展示给学生</el-button>
                  <el-button
                    type="primary"
                    @click="makeWxAppReport">生成报告连接图片</el-button>
                  <el-button
                    type="primary"
                    @click="resetAnswer">重置答题状态</el-button>
                  <router-link
                    target="_blank"
                    :to="{ name: 'ieltsHistory', params: { crmid: this.$route.params.crmid } }">
                    <el-button type="primary">历史记录</el-button>
                  </router-link>
                </el-col>
              </el-row>
            </div>
            <div
              class="ieltsTest-cont"
              v-if="status===1">
              暂无用户答题信息
              <el-row v-if="true"> <!-- 列表显示-->
                <el-col :span="5"/>
                <el-col :span="19">
                  <router-link
                    target="_blank"
                    :to="{ name: 'ieltsHistory', params: { crmid: this.$route.params.crmid } }">
                    <el-button type="primary">历史记录</el-button>
                  </router-link>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';

export default {
  data() {
    return {
      status: 0,
      userStatus: {
        paper_type: 0
      },
      report: [],
    };
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
  },
  methods: {
    getData() {
      this.$http._post({
        url: `/index/ielts_test/getCurrent/crmid/${this.$route.params.crmid}`,
      }).then((data) => {
        if (data.data !== '') {
          this.status = data.data.status;
          if (typeof (data.data.userStatus) === 'object') {
            this.userStatus = data.data.userStatus;
          }
          if (data.data.status === 0) {
            this.report = data.data.report;
          }
        } else {
          this.$message.error('数据错误');
        }
      });
    },
    save() {
      this.$http._post({
        url: '/index/ielts_test/save',
        data: {
          crmid: this.$route.params.crmid,
          history_id: this.report.history_id,
          report_json: this.report.report_json,
        }
      }).then((data) => {
        if (data.data !== '') {
          this.$message.success('保存成功');
        } else {
          this.$message.error('数据错误');
        }
      });
    },
    /**
     * 开通尊享版
     */
    changeVersion() {
      this.$http._post({
        url: '/index/ielts_test/changeVersion',
        data: { crmid: this.$route.params.crmid, history_id: this.report.history_id }
      }).then((data) => {
        if (data.result === 0) {
          this.$message.success(data.data);
          window.location.reload();
        } else {
          this.$message.error(data.data);
        }
      });
    },
    /**
     * 重置用户答题状态
     */
    resetAnswer() {
      this.$http._post({
        url: '/index/ielts_test/resetAnswer',
        data: { crmid: this.$route.params.crmid, history_id: this.report.history_id }
      }).then((data) => {
        if (data.result === 0) {
          this.$message.success(data.data);
          window.location.reload();
        } else {
          this.$message.error(data.data);
        }
      });
    },
    /**
     * 下载小程序码
     */
    makeWxAppCode(event, page = 'pages/index/index') {
      console.log(event);
      this.$http.downloadFile({
        url: '/index/ielts_test/makeWxAppCode',
        data: { crmid: this.$route.params.crmid, page },
        filename: `ielts_test_${this.$route.params.crmid}.png`
      });
    },
    /**
     * 下载报告二维码
     */
    makeWxAppReport(event, page = 'pages/index/index') {
      console.log(event);
      this.$http.downloadFile({
        url: '/index/ielts_test/makeWxAppReport',
        data: { crmid: this.$route.params.crmid, page },
        filename: `ielts_report_${this.$route.params.crmid}.png`
      });
    }
  },
  mounted() {
    this.getData();
  },
};
</script>
<style scoped>
  .basic-title{
    cursor: inherit;
  }
  .basic-title span {
    margin-left: 30px;
  }
  .ieltsTest-button{
    margin-left: 245px;
  }
  .ieltsTest-left span{
    margin-right: 30px;
    display: inline-block;
    min-width: 135px;
    padding: 10px;
    border: 1px solid #409EFF;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #4e4e4e;
  }
  .ieltsTest-left span em {
    display: block;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #409EFF;
  }
  .ieltsTest-left-top span {
    border-radius: 10px;
    background: #fff;
    border: #409EFF solid 2px;
    box-shadow: 1px 1px 3px #999;
  }
  .ieltsTest-left-top span em{
    font-size: 16px;
    font-weight: 400;
    color: #409EFF;
  }
  .ieltsTest-left-top span em:first-of-type{
    font-size: 14px;
  }
  .ieltsTest-left-top span em:last-of-type{
    font-size: 18px;
    color: #f00;
  }
  .ieltsTest-cont{
    margin: 20px;
  }
  .ieltsTest-cont .el-col-4 {
    width: auto;
  }
  .ieltsTest-cont .el-row{
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .ieltsTest-right{
    min-width: 870px;
  }
  .ieltsTest-right-top {
    padding: 0;
    border: none;
    min-height: auto;
  }
  .ieltsTest-right .ieltsTest-right-box{
    width: 30%;
    float: left;
  }
  .ieltsTest-right span{
    padding: 5px 0;
    display: block;
    font-size: 14px;
    color: #409EFF;
  }
  .ieltsTest-right span i{
    margin-right: 6px;
    color: #303133;
    font-size: 16px;
    font-weight: bold;
  }
</style>
